"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>usePromptRetrieval
});
const external_react_namespaceObject = require("react");
const analytics_js_namespaceObject = require("../analytics/analytics.js");
var analytics_js_default = /*#__PURE__*/ __webpack_require__.n(analytics_js_namespaceObject);
const browserStorage_js_namespaceObject = require("../utils/browserStorage.js");
const sessionUtils_js_namespaceObject = require("../utils/sessionUtils.js");
const external_UseRefreshSessionAccess_js_namespaceObject = require("./UseRefreshSessionAccess.js");
var external_UseRefreshSessionAccess_js_default = /*#__PURE__*/ __webpack_require__.n(external_UseRefreshSessionAccess_js_namespaceObject);
const usePromptRetrieval_usePromptRetrieval = (args)=>{
    const [statusMsg, setStatusMesg] = (0, external_react_namespaceObject.useState)('');
    const [tabVisible, setTabVisible] = (0, external_react_namespaceObject.useState)(true);
    const { cguid, chatMessages, isSessionActive, limit = 5, productId = 0, requestFrom = '', retrieveUrl, setChatMessages, setLastPromptId, setRetrievalLoading } = args;
    external_UseRefreshSessionAccess_js_default()();
    const visibilityChangeTimeout = (0, external_react_namespaceObject.useRef)(null);
    (0, external_react_namespaceObject.useEffect)(()=>{
        const handleVisibilityChange = ()=>{
            if ('visible' === document.visibilityState) visibilityChangeTimeout.current = setTimeout(()=>{
                setTabVisible(true);
            }, 500);
            else {
                clearTimeout(visibilityChangeTimeout.current || 0);
                setTabVisible(false);
            }
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return ()=>{
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            if (visibilityChangeTimeout.current) clearTimeout(visibilityChangeTimeout.current);
        };
    }, [
        isSessionActive
    ]);
    (0, external_react_namespaceObject.useEffect)(()=>{
        if (!isSessionActive || !tabVisible || 'undefined' == typeof window) return void setStatusMesg('Failed');
        const shouldFetch = browserStorage_js_namespaceObject.browserStorageManager.getBrowserStorage()?.getUserMessageCount() !== chatMessages?.filter((message)=>message?.role === 'user' && message?.content !== '').length || 0 === chatMessages.length;
        const abortController = new AbortController();
        setTimeout(()=>{
            abortController.abort();
        }, 30000);
        const fetchMe = async ()=>{
            const pennysid = browserStorage_js_namespaceObject.browserStorageManager.getBrowserStorage()?.getItem('pennysid') ?? '';
            return await fetch(retrieveUrl, {
                method: 'POST',
                signal: abortController.signal,
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    pennysid,
                    cguid,
                    limit,
                    isSessionActive,
                    productId,
                    requestFrom
                })
            });
        };
        if (shouldFetch) {
            setRetrievalLoading(true);
            fetchMe().then(async (result)=>{
                const sessionResult = await result?.json();
                if (sessionResult?.token) sessionStorage.setItem('pennysid', sessionResult.token);
                else analytics_js_default().log({
                    source: 'usePromptRetrieval',
                    message: `Invalid token sent, token is ${sessionResult?.token}`
                });
                const sessionData = sessionResult.data;
                if (sessionData?.length) {
                    const sessionChatMessage = sessionData.map((item)=>(0, sessionUtils_js_namespaceObject.transformSessionResponse)(item));
                    setLastPromptId(sessionData[0]?.promptId);
                    setChatMessages(sessionChatMessage);
                    setStatusMesg('Success');
                }
            }).catch((e)=>{
                setStatusMesg('Failed');
                analytics_js_default().log({
                    source: 'Chatbot retrieve error',
                    message: e.message
                });
            }).finally(()=>setRetrievalLoading(false));
        }
    }, [
        isSessionActive,
        tabVisible
    ]);
    return {
        statusMsg
    };
};
const usePromptRetrieval = usePromptRetrieval_usePromptRetrieval;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
